import { computed, ref } from 'vue';

interface Toast {
    id: number;
    visible: boolean;
    button: boolean;
    message: string;
    type: string;
    title: string;
}

const toastState = ref<Toast[]>([]);
let toastIdCounter = 0;

export const useToast = () => {
    const show = (
        message: string,
        title: string,
        type = 'success',
        duration = 3000,
        button = false
    ) => {
        const toastId = ++toastIdCounter;

        const newToast: Toast = {
            id: toastId,
            visible: true,
            button,
            message,
            type,
            title
        };

        toastState.value.push(newToast);

        setTimeout(() => {
            hide(toastId);
        }, duration);
    };

    const hide = (toastId: number) => {
        const index = toastState.value.findIndex(toast => toast.id === toastId);
        if (index !== -1) {
            toastState.value.splice(index, 1);
        }
    };

    const hideAll = () => {
        toastState.value = [];
    };

    return {
        toasts: computed(() => toastState.value),
        show,
        hide,
        hideAll
    };
};
